<template>
	<div>
		<Container>
			<TopBar />
			<div class="content">
				<div class="search">
					<p class='bogo_tips' v-if='bogo_switch_tip' v-html="bogo_switch_tip"></p>
					<Form class='search-form' ref="formInline" :model="search" inline style='text-align: center;'>
						<div style="display:flex;align-items: center;justify-content: center;">
							<FormItem prop="beginTime">
								<DatePicker size='large' type="date" v-model='search.beginTime' placement="bottom-end" placeholder="開始日期(Choose Date)"  @keyup.enter.native='searchOrders'></DatePicker>
							</FormItem>
							<FormItem>
								<span>至</span>
							</FormItem>
							<FormItem prop="endTime">
								<DatePicker size='large' type="date" v-model='search.endTime' placement="bottom-end" placeholder="結束日期(Choose Date)"  @keyup.enter.native='searchOrders'></DatePicker>
							</FormItem>
						</div>
						<div>
							<FormItem style="display: inline-block;">
								<Button size='large' :loading='btnloading' type="primary"  @click='searchOrders'>搜索(Search)</Button>
							</FormItem>
						</div>
					</Form>
				</div>
				<Tabs v-model="paymentStatus" >
					<TabPane label="已付款(Paid)" name="Pay"></TabPane>
			        <TabPane label="未付款(Not Yet Paid)" name="UnPay"></TabPane>
			        <TabPane v-if='showMerge' label="待合併發貨(On Hold for Group Delivery)" name="-2"></TabPane>
			    </Tabs>
				<!-- <omsOrders ref='omsOrders' :beginTime='search.beginTime' :endTime='search.endTime' v-show='paymentStatus == "All"'/> -->
			    	<Table class='orderTable' :loading="loading" stripe :columns="columns" :data="orders" no-data-text="暫無數據"></Table>
					<div class='xs-cells' v-for='order in orders' style="border-bottom: 1px dashed #d4d4d4;padding-top: 10px;">
						<Row class='xs-cells-item' style='margin-top: 0.2rem;'>
							<Col span='12'>訂單日期(Order Date)</Col>
							<Col span='12' style='text-align: center;' v-if="order.CreateTime">{{order.CreateTime.substr(0,19).replace('T',' ')}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>訂單編號(Order Number)</Col>
							<Col span='12' style='text-align: center;'>{{order.OrderNo}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>訂單金額/PV(Order Amount/PV)</Col>
							<Col span='12' style='text-align: center;'>{{order.TotalPaid}}&nbsp;/&nbsp;{{order.PValue}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>訂單渠道(Order Channel)</Col>
							<Col span='12' style='text-align: center;'>{{order.Channel}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>合併訂單號(Group delivery order no.)</Col>
							<Col span='12' style='text-align: center;text-decoration :underline;color:#B176C5;font-size:0.65rem'><span @click='goMergeOrders(order)'>{{order.MergeOrderNo}}</span></Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>訂單狀態(Order Status)</Col>
							<Col span='12' style='text-align: center;'>{{typePlay(order)}}</Col>
						</Row>
						<Row class='flex-line'>
							<!-- <div span='6' style='text-align: right'><Button :style='{color:disabledReturn(order)?"#ccc":"#B176C5"}' type='text' @click='returnSales(order)' :disabled='disabledReturn(order)'>{{returnTitle(order)}}</Button></div>
							<div span='6' style='text-align: right'>
								<Button v-if='canRepay(order)' style='color:#B176C5;' type='text' @click='qxpay(order.OrderNo)'>取消</Button>
								<Button v-else-if='canCancelPaid(order)' style='color:#B176C5;' type='text' @click='cancelOrder(order)'>取消</Button>
							</div> -->
							<Col span='12' style='text-align: right'><Button v-if='canRepay(order)' style='color:#B176C5;' type='text' @click='gotoPay(order.OrderNo)'>繼續付款</Button></Col>
							<Col span='12' style='text-align: right'><Button style='color:#B176C5;' type='text' @click='showDetail(order)'>查看</Button></Col>
						</Row>
					</div>
					<div class="tip">
						<p v-if='paymentStatus == "Pay" && hasMergingOrders' v-html='tipForPay'></p>
						<div v-else-if='paymentStatus == "-2" && hasMergingOrders' v-html='tipForMerge'></div>
					</div>
					<div class="page" v-if='paymentStatus == "-2"'>
						<Button @click='goMergeOrders()' v-if='orders.length' type='primary'>合併發貨(Combined shipment)</Button>
					</div>
					
					<div class="page" v-else>
						<Button @click='loadData(0)' :disabled='page==0' class='goon-btn' size='large' type='primary'>上一頁(Last Page)</Button>
						&nbsp;
						<Button @click='loadData(1)' :disabled='nextBtn' class='goon-btn' size='large' type='primary'>下一頁(Next Page)</Button>
					</div>
			</div>
		</Container>
		<transition mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import omsOrders from "./omsOrders";

import util from "@/config/util";
import {cvoUrl} from '@/config/env'
import { api_methods } from "@/service/loadData";
const now = new Date()
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
	data() {
		return {
			paymentStatus:'Pay',
			fromPath: null,
			loading: true,
			btnloading: false,
			reload: false,
			showMerge:false,
			search: {
				orderNo: null,
				channel: null,
				beginTime:new Date(now.getFullYear(),now.getMonth(),now.getDate() - 30),
				endTime: now,
				time: null,
				orderStatus: null,
				PageIndex: 0,
				PageSize: 20
			},
			o_columns: [
				{
					key: "CreateTime",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "訂單日期"),
							h("div", null, "Order Date")
						]);
					},
					render: (h, params) => {
						let innerHtml = params.row.CreateTime.substr(
							0,
							19
						).replace("T", " ");
						return h("div", null, innerHtml);
					}
				},
				{
					key: "OrderNo",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "訂單編號"),
							h("div", null, "Order Number")
						]);
					},
					render: (h, params) => {
						let forOrder = this.forOrder(params.row);
						return h("div", [
							h("div", null, params.row.OrderNo),
							h("p", { style: { color: "#3484e0" } }, forOrder)
						]);
					}
				},
				{
					key: "total",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "訂單金額/PV"),
							h("div", null, "Order Amount/PV")
						]);
					},
					render: (h, params) => {
						let innerHtml = `HK$${params.row.TotalPaid} / ${params.row.PValue}`;
						return h("div", null, innerHtml);
					}
				},
				{
					key: "Channel",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "訂單渠道"),
							h("div", null, "Order Channel")
						]);
					}
				},{
					key: "MergeOrderNo",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "合併訂單號"),
							h("div", null, "Group delivery order no.")
						]);
					},
					render:(h,params)=>{
						let no = params.row.MergeOrderNo
						if (no) {
							return h('div',[h('a',{
								style: {
									textDecoration :'underline',
									color: "#B176C5",
									fontSize: "0.13rem"
								},
								on: {
									click: () => {
										this.goMergeOrders(params.row)
									}
								}
							},no)])
						}
						return null
					}
				},
				{
					key: "OrderStatus",
					// width: 300,
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "訂單狀態"),
							h("div", null, "Order Status")
						]);
					},
					render: (h, params) => {
						let innerHtml = this.typePlay(params.row);
						var text = "";
						var textEn = "";
						if (
							params.row.Channel == "Wechat" &&
							(params.row.OrderStatus == "UnPay" ||
								params.row.OrderStatus == "Paying")
						) {
							text += "需在微信端繼續付款";
							textEn += "payment should be continued in Wechat";
						}
						return h("div", [
							h("div", null, innerHtml),
							h("p", null, text),
							h("b", null, textEn)
						]);
					}
				},
				// {
                //     key: 'action',
                //     width: 150,
                //     align: 'center',
                //     renderHeader:(h,index)=>{
                //     	return h('div',[
                //     		h('div',null,'退貨'),h('div',null,'Returned Purchase')])
                //     },
                //     render: (h, params) => {
                //         return h('div', [
                //             h('Button', {
                //                 props: {
                //                     type: 'primary',
                //                     size: 'small',
                //                     disabled:this.disabledReturn(params.row)
                //                 },
                //                 style: {
                //                     marginRight: '5px'
                //                 },
                //                 on: {
                //                     click: () => {
                //                     	this.returnSales(params.row)
                //                     }
                //                 }
                //             }, this.returnTitle(params.row.orderCancelStatus))
                //         ]);
                //     }
                // },
				// {
				// 	key: "action",
				// 	width: 250,
				// 	align: "center",
				// 	renderHeader: (h, index) => {
				// 		return h("div", [
				// 			h("div", null, "操作"),
				// 			h("div", null, "Operation")
				// 		]);
				// 	},
				// 	render: (h, params) => {
				// 		var model = params.row;
				// 		var btnList = [];
				// 		if (this.canRepay(model)) {
				// 			btnList.push(
				// 				h(
				// 					"a",
				// 					{
				// 						props: {
				// 							type: "text",
				// 							size: "small"
				// 						},
				// 						style: {
				// 							marginRight: "5px",
				// 							// marginBottom: '5px',
				// 							// marginTop: '5px'
				// 							color: "#B176C5",
				// 							fontSize: "0.13rem"
				// 						},
				// 						on: {
				// 							click: () => {
				// 								this.gotoPay(
				// 									params.row
				// 								);
				// 							}
				// 						}
				// 					},
				// 					"繼續付款(Continue to pay)"
				// 				)
				// 			);
				// 			btnList.push(
				// 				h(
				// 					"div",
				// 					{
				// 						props: {
				// 							type: "text",
				// 							size: "small"
				// 						},
				// 						style: {
				// 							marginRight: "5px",
				// 							cursor:'pointer',
				// 							// marginBottom: '5px',
				// 							// marginTop: '5px'
				// 							color: "#B176C5",
				// 							fontSize: "0.13rem"
				// 						},
				// 						on: {
				// 							click: () => {
				// 								this.qxpay(params.row.OrderNo);
				// 							}
				// 						}
				// 					},
				// 					"取消訂單(Cancel Order)"
				// 				)
				// 			);
				// 		}
				// 		let cancelable = this.canCancelPaid(model)
				// 		if (cancelable) {
				// 			btnList.push(h("a",{
				// 				props: {
				// 					type: "text",
				// 					size: "small"
				// 				},
				// 				style: {
				// 					marginRight: "5px",
				// 					color: "#B176C5",
				// 					fontSize: "0.13rem"
				// 				},
				// 				on: {
				// 					click: () => {
				// 						this.cancelOrder(params.row)
				// 					}
				// 				}},"取消訂單(Cancel Order)")
				// 			);
				// 		}
						
				// 		return h("div", btnList);
				// 	}
				// },
				{
					key:'detail',
					renderHeader:(h,index)=>{
                    	return h('div',[
                    		h('div',null,'明細'),h('div',null,'Detail')])
                    },
                    render: (h, params) => {
                    	var btnList = [];
                    	btnList.push(
							h(
								"a",
								{
									props: {
										type: "text",
										size: "small"
									},
									style: {
										// marginRight: '5px',
										// width:'150px'
										display: "block",
										color: "#B176C5",
										fontSize: "0.13rem"
									},
									on: {
										click: () => {
											this.show(params.row);
										}
									}
								},
								"    明細(Details)    "
							)
						);
						return h("div", btnList);
                    }


				}
			],
			columns:[],
			orders: [],
			total: 0,
			currentPage: 1,
			page: 0,
			nextBtn: false,
			tipForPay:'',
			tipForMerge:'',
		};
	},
	created() {
		this.$nextTick(function() {
			this.getTipDetailAction('Tips_Product_Merge_Pay').then(res=>{
				this.tipForPay = res.ExtStr1
                this.tipForMerge = res.Content
                this.showMerge = this.timeComparison(res.ValidFrom,res.ValidTo)
			})
			this.columns = this.o_columns;
			if(this.$route.query&&this.$route.query.from=='merge'){
                 this.filterMergeOrders();
            }
			this.initData();
		  
		});
	},
	mounted() {},
	watch: {
		reload(cur) {
			if (cur) {
				this.initData();
				this.reload = false;
			}
		},
		paymentStatus(cur){
			this.orders = []
			this.reloadOrders(cur);
			// if (cur == 'UnPay') {
			// 	let columns = [...this.o_columns]
			// 	columns.splice(6, 1)
			// 	this.columns = columns
			// } else {
			// 	this.columns = this.o_columns
			// }
		},
	},
	mixins: [],
	components: {
		TopBar,
		omsOrders,
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken",'getUserId', "getVipNo",]),
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			token: state => state.common.userToken,
		}),
		screenW() {
			return document.body.clientWidth;
		},
		hasMergingOrders(){
			return this.orders.some(item=>((item.VirtualFlag == 1 || item.VirtualFlag == 2)&&item.OrderStatus == 'Pay'))
		},
		isMobile() {
			if (document.body.clientWidth <= 768) {
				return true;
			}
			return false;
		},
	},
	methods: {
		...mapMutations(["SAVE_ORDER", "SET_ORDERNN"]),
		...mapActions([
			"getWXOrdersAction",
			"getOrderEncryptionAction",
			"getOrderUserInfoAction",
			'cancelHistoryOrderAction',
			'getTipDetailAction',
		]),
		timeComparison(str, str1) {
			var valid_from = !str ? null : util.formatDate.dateFromStr(str);
			var valid_to = !str1 ? null : util.formatDate.dateFromStr(str1);
			var now = new Date();
			return (
				(valid_from <= now || !valid_from) &&
				(valid_to >= now || !valid_to)
			);
		},
		filterMergeOrders(){
			this.paymentStatus = this.paymentStatus == '-2' ? 'Pay':'-2'
		},
		async goMergeOrders(order){
			let no = order && 'confirm,express'.indexOf(order.OrderStatus.toLowerCase()) != -1 ? order.MergeOrderNo:undefined;
			this.$router.push({
				path:'/order/mergeorders',
				query:{
					no,
				}
			})
		},
		returnSales(order){
			location = `${cvoUrl}/vo/index.html#/orders/refunds?orderNo=${order.OrderNo}-${order.OrderNo}&channel=${order.Channel}&token=${this.token}`
		},
		canRepay(model) {
			return (model.OrderStatus == "UnPay" || model.OrderStatus == "Paying") && (model.OptVipNo == null || model.OptVipNo == vipNo) && (model.Channel == "MyO"||model.Channel == "Manual")
		},
		canCancelPaid(model) {
			let now = new Date()
			let paytime = Date.fromStr(model.Paytime)
			let cancelable = model.DeliveryStoreId == '501' 
							&& (this.paymentStatus == 'Pay' || this.paymentStatus == '-2') 
							&& model.OrderStatus != 'Disable' &&  model.OrderStatus != 'Disabling'
							&& ((model.VirtualFlag == 1 || model.VirtualFlag == 2) ? 'Confirm,Express'.indexOf(model.OrderStatus) == -1:true) //合併發貨訂單,合併後不能取消
							&& model.VirtualFlag != 10  //虛擬運費
							&& model.VirtualFlag != 20  //HWG補贈品訂單
							&& now - paytime < 1800000
			return cancelable
		},
		disabledReturn(order){
			let now = new Date()
			let payTime = Date.fromStr(order.Paytime)
			return order.orderCancelStatus == 6 || 'Express'.indexOf(order.OrderStatus) == -1 || order.Channel.toLowerCase() == 'oms' || now - payTime < 1800000 || order.DeliveryStoreId != '501'
		},
		returnTitle(status){ //orderCancelStatus
			switch(parseInt(status)){
				case 1:
					return '退貨申請'
				case 2:
					return '申請中'
				case 3:
					return '已申請'
				case 4:
					return '處理中'
				case 5:
					return '退貨完成'
				case 6:
				default:
					return '不能退貨'
			}
		},
		qxpay(OrderNo) {
			this.$Modal.confirm({
				title: "取消訂單",
				content: "確定要取消訂單嗎？",
				onOk: () => {
					api_methods
						.CancelOrder(
							this.getAccessToken,
							this.getUserId,
							OrderNo
						)
						.then(result => {
							if (
								result &&
								result.data &&
								result.data.value == 1
							) {
								this.$Message.success('訂單取消成功')
								this.initData()
							} else {
								this.$Modal.info({
									title: "信息",
									content: "訂單取消失敗"
								});
							}
						});
				}
			});
		},
		cancelOrder(order) {
			this.$Modal.confirm({
                title: '確認取消？',
                cancelText:'不取消',
                content: `<p>確認取消訂單：${order.OrderNo}</p><p>取消成功後，訂單款項及使用點數積分1個工作日左右原路退回支付賬戶</p>`,
                onOk:async () => {
                	let date = Date.fromStr(order.Paytime)
                	let now = new Date()
                	if (now - date > 1800000) {
                		this.$Message.error('已經超出取消時間，請收到貨後走退貨流程')
                	} else {
                    	let response = await this.cancelHistoryOrderAction(order.OrderNo)
                    	if (response.isOK) {
                    		this.$Message.success('訂單取消處理中，請稍後查看')
                    		this.initData()
                    	}else {
                    		this.$Message.error('訂單處理中，請稍後重試')
                    	}
                	}
                	
                },
                onCancel: () => {
                    
                }
            });
		},
		forOrder(item) {
			if (item.OptVipNo == this.getVipNo) {
				//幫別人下單
				return "協助顧客訂購:" + this.passwordName(item.Name);
			}
			if (item.VipNo == this.getVipNo) {
				//別人幫我下單
				return this.passwordName(item.OptName) + "（協助下單）";
			}
		},
		formatNoticeDate(date) {
			if (date && date != "") {
				return util.formatDate.format(date);
			}
			return "";
		},
		passwordName(name) {
			var newName = "";
			if (name) {
				if (name.length > 2) {
					newName =
						name.charAt(0) + "*" + name.charAt(name.length - 1);
				} else {
					newName = name.charAt(0) + "*";
				}
			}
			return newName;
		},
		typePlay(item) {
			const OrderStatus = {
				"UnPay":"未付款",
				"Pay":"已付款",
				"Paying":"付款中",
				"Cancel":"取消",
				"Close":"取消",
				"Confirm":"已付款",
				"Oubound":"完成",
				"Express":"已發貨",
				"PickUpEnd":"已完成",
				"Sign":"簽收",
				"Complete":"完成",
				"Returned":"退貨完成",
				"Disable":"作廢",
				"Disabling":'作廢處理中',
			}
			if (item.VirtualFlag == 1 || item.VirtualFlag == 2) {
				if (item.OrderStatus == 'Pay') {
					return '待合併發貨'
				} else if ('Confirm,Express'.indexOf(item.OrderStatus) != -1 ) {
					return '已合併發貨'
				}
			}
			return OrderStatus[item.OrderStatus] || ''
		},
		show(order) {
			this.SAVE_ORDER(order);
			console.log(order)
			this.$router.push(
				`/order/detail?orderNo=${order.OrderNo}&channel=${order.Channel}`
			);
		},
		showDetail(order) {
			this.SAVE_ORDER(order);
			this.$router.push(
				`/order/detail?orderNo=${order.OrderNo}&channel=${order.Channel}`
			);
		},
		reloadOrders(status,type) {
			this.page = 0;
			// if (status == 'All') {
			// 	this.$refs.omsOrders.reloadData()
			// } else {
				this.initData(type || 0,status)
			// }
		},
		async initData(type,orderStatus) {
			//this.fromPath=this.$from_path;
			if (!this.$from_path || this.$from_path.indexOf("lrp") == -1) {
				this.fromPath = "/order/product";
			} else {
				this.fromPath = "/lrp/lrplist";
			}

			if (!type) {
				//await this.getOrderUserInfoAction();
			}
			// if (this.paymentStatus == 'All') {
			// 	this.$refs.omsOrders.reloadData()
			// 	return
			// }
			this.loading = true;

			let beginTime = util.formatDate.format(this.search.beginTime);
			let endTime = util.formatDate.format(this.search.endTime);

			let response = await this.getWXOrdersAction({
				userid: this.userInfo.value.binding.user_id,
				beginTime,
				endTime,
				orderStatus:this.paymentStatus || "UnPay",
				id: this.page
			});
			this.loading = false;

			if (response) {
				if (response.length < 10) {
					this.nextBtn = true;
				} else {
					this.nextBtn = false;
				}
				this.orders = response;
				// this.total = response.total;
			} else {
				this.nextBtn = true;
				this.orders = [];
			}
		},
		async loadData(type) {
			if (type == 0) {
				this.page--;
			} else {
				this.page++;
			}
			await this.initData(1);
		},
		async searchOrders() {
			this.page = 0;
			this.reloadOrders(this.paymentStatus,1)
		},
		async gotoPay({OrderNo,VirtualFlag}) {
			var res = await this.getOrderEncryptionAction(OrderNo);
			if (res) {
				this.SET_ORDERNN({ orderno: res, os: OrderNo });
				if (VirtualFlag == 10) {
					this.$router.push({
						path: "/order/payment",
						query: {
							orderno: res,
							os: OrderNo
						}
					});
				} else {
					this.$router.push("/order/confirm");
				}
				
				//location = `${ecUrl}Client/index.html#/order/confirm?token=${this.getAccessToken}&orderno=${res}&os=${OrderNo}`;
			}
		},
		back() {
			this.$router.go(-1);
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.topbar {
	background-color: #f3f4f5;
	a {
		line-height: 40px;
		margin-left: 10.42vw;
		&:hover {
			color: $theme-color;
		}
	}
}
.content {
	padding-top: 10px;
	width: 80%;
	margin: auto;
	list-style: none;
	margin-bottom: 50px;
}
.search {
	margin-top: 0.5rem;
	margin-bottom: 0.2rem;
	.bogo_tips {
		@include fontSize($font-size-14);
		text-align: center;
		margin-bottom: 30px;
	}
}
.orderTable {
	margin-bottom: 0.3rem;
	//@include fontSize($font-size-16);
}
.xs-cells {
	display:none;
}
.page {
	margin: 0.2rem auto;
	text-align: center;
}
.xs-orders {
	color: #495060;
	font-size: 0.65rem;
	background-color: #fefefe;
	border: 1px solid rgba(0, 0, 0, 0.05);
	margin-bottom: 0.3rem;
}
.xs-order-item {
	margin-bottom: 0.2rem;
}
.breadcrumb {
	.goBack {
		float: right;
		margin-right: 20px;
	}
}
.tip {
	color:$theme-color;
}
.search-form {
	display:flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
}
@media (max-width: 768px){
	.orderTable {
		display:none;
	}
	.xs-cells {
		display:block;
		.flex-line {
			display:flex;
			justify-content: flex-end;
		}
	}
	.search-form {
		font-size: 12px !important;
	}
	.content {
		width: 95%;
	}
}
</style>